import { useEffect, useState } from "react";
import axios from "axios";
import { CircularProgress, Box } from "@mui/material"; // optional: replace with your Loader component
import { Page } from "components";
import { Apis } from "utils";

type Props = {
  children: React.ReactNode;
};

export const HealthCheck = ({ children }: Props) => {
  const [isUp, setIsUp] = useState<boolean>(false);
  const [errorCount, setErrorCount] = useState<number>(0);

  useEffect(() => {
    let isCancelled = false;

    const runProcess = async () => {
      try {
        const res = await Apis.currentHealthCheck();
        if (!isCancelled && res.status === 200) {
          setIsUp(true);
        }
      } catch (err) {
        if (!isCancelled) {
          setErrorCount((prev) => prev + 1);
          setTimeout(runProcess, 1000); // retry after 1 second
        }
      }
    };

    runProcess();

    return () => {
      isCancelled = true;
    };
  }, []);

  if (!isUp) return <Page.Loader message="Server is waking up..." />;

  return <>{children}</>;
};
